<div class="host-base-image-upload">
  <div class="list">
    <div class="item" *ngFor="let image of listOfImage">
      <img
        class="image"
        style="cursor: pointer;"
        *ngIf="showBigImg"
        [src]="image?.urls?.original_url"
        alt=""
        (click)="showLargeImg(image?.urls?.large_url)"
      />
      <img
        class="image"
        *ngIf="!showBigImg"
        [src]="image?.urls?.original_url"
        alt=""
      />
      <img
        src="/assets/icon/upload-delete.png"
        class="delete"
        (click)="onDeleteImage(image)"
      />
    </div>

    <nz-upload
      *ngIf="listOfImage?.length < maxSize"
      class="item"
      nzAction="/api/upload/image"
      [nzShowUploadList]="false"
      [nzBeforeUpload]="beforeUpload"
      [nzAccept]="'image'"
      (nzChange)="handleChange($event)"
    >
      <div class="upload-btn">
        <i nz-icon nzType="plus" nzTheme="outline"></i>
      </div>
    </nz-upload>
  </div>
</div>
